export default __webpack_public_path__ + "static/media/correct_tick.ec5b601d.svg";